import styles from './FJAnimateImageModal.module.less';
import FJConfig from '../../../config/FJConfig';
import FJButton, { FJButtonType } from '../../../common/components/FJButton/FJButton.jsx';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import FJLocalStore from '../../../store/FJLocalStore.js';
import FJCancelIcon from '../../../assets/svg/cancel.svg?react';

const FJAnimateImageModal = props => {
    const { onTryNow, active, onClose } = props;
    return (
        <div className={classNames(styles.container, { [styles.active]: active })}>
            <div className={styles.left}>
                <video src={FJConfig.animateImageModalVideoUrl} autoPlay muted loop />
            </div>
            <div className={styles.right}>
                <div className={styles.title}>{FJLocalStore._('animate-your-ai-art')}</div>
                <div className={styles.description}>
                    {FJLocalStore._('bring-your-ghibli-style-image-to-life-with-ai-image-to-video-tool')}
                </div>
                <FJButton
                    className={styles.button}
                    type={FJButtonType.GRADIENT}
                    onClick={onTryNow}
                    text={FJLocalStore._('try-now')}
                />
            </div>
            <div className={styles.close_box} onClick={onClose}>
                <FJCancelIcon />
            </div>
        </div>
    );
};

FJAnimateImageModal.propTypes = {
    onTryNow: PropTypes.func,
    active: PropTypes.bool,
    onClose: PropTypes.func,
};

export default FJAnimateImageModal;
